import { createRoot } from 'react-dom/client';

import App from '@/App';
import { livePreviewHost } from '@/api/livePreviewHost';
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';
import '@/i18n';
import { installAutoHideScrollbars } from '@/lib/autoHideScrollbars';

import './index.css';

installAutoHideScrollbars();
void livePreviewHost.check();

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary scope="app">
    <App />
  </ErrorBoundary>,
);
